var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as Cookie from 'es-cookie';
import { REACT_APP_PKG_NAME, REACT_APP_APP_VERSION, REACT_APP_AUTH0_DOMAIN, REACT_APP_AUTH0_CLIENT_ID, REACT_APP_AUTH0_CALLBACK } from './env';
var CODE_RE = /[?&]code=[^&]+/;
var STATE_RE = /[?&]state=[^&]+/;
var ERROR_RE = /[?&]error=[^&]+/;
export var hasAuthParams = function (searchParams) {
    if (searchParams === void 0) { searchParams = window.location.search; }
    return (CODE_RE.test(searchParams) && STATE_RE.test(searchParams)) ||
        ERROR_RE.test(searchParams);
};
var OAuthError = /** @class */ (function (_super) {
    __extends(OAuthError, _super);
    function OAuthError(error, error_description) {
        var _this = _super.call(this, error_description || error) || this;
        _this.error = error;
        _this.error_description = error_description;
        return _this;
    }
    return OAuthError;
}(Error));
var domainScopeKey = 'lucid.spa.domain.scopes';
var normalizeErrorFn = function (fallbackMessage) { return function (error) {
    if ('error' in error) {
        return new OAuthError(error.error, error.error_description);
    }
    if (error instanceof Error) {
        return error;
    }
    return new Error(fallbackMessage);
}; };
export var loginError = normalizeErrorFn('Login failed');
export var tokenError = normalizeErrorFn('Get access token failed');
var cookieAttrs = {
    secure: true,
    path: '/'
};
export var setDomainScopeCookie = function (scopes) {
    return Cookie.set(domainScopeKey, scopes || '', cookieAttrs);
};
export var getDomainScopes = function () {
    return Cookie.get(domainScopeKey);
};
export var removeDomainScopesCookie = function () {
    return Cookie.remove(domainScopeKey, cookieAttrs);
};
var getDefaultScopes = function (scopes) {
    var defaultScopes = 'app:las openid email profile';
    var scopesFromApp = Array.isArray(scopes) ? scopes.join(' ') : scopes;
    var scopesFromStorage = getDomainScopes();
    // even if both scopes are undefined or null it works and also it remove empty spaces
    return [defaultScopes, scopesFromApp, scopesFromStorage].join(' ').trim();
};
export var getAuth0Configuration = function (_a) {
    var callbackUrl = _a.callbackUrl, scopes = _a.scopes;
    return ({
        auth0Client: {
            name: REACT_APP_PKG_NAME,
            version: REACT_APP_APP_VERSION
        },
        useRefreshTokens: true,
        leeway: 30,
        useCookiesForTransactions: false,
        audience: 'https://api.luc.id',
        domain: REACT_APP_AUTH0_DOMAIN,
        client_id: REACT_APP_AUTH0_CLIENT_ID,
        redirect_uri: callbackUrl || REACT_APP_AUTH0_CALLBACK || window.location.origin,
        advancedOptions: {
            defaultScope: getDefaultScopes(scopes)
        }
    });
};
export var getUnauthorizedRoles = function (userRoles, requiredRoles, rule) {
    if (userRoles === void 0) { userRoles = []; }
    if (requiredRoles === void 0) { requiredRoles = []; }
    if (rule === void 0) { rule = 'and'; }
    if (!requiredRoles.length) {
        return [];
    }
    var rolesUserDoesntHave = requiredRoles.filter(function (role) { return !userRoles.some(function (userRole) { return userRole.startsWith(role); }); });
    if (rule === 'or') {
        // Let's say requiredRoles has 3 roles and rolesUserDoesntHave has 2
        // it means the user has at least one of the needed roles
        // If the rolesUserDoesntHave has all the 3, it means he doesnt have any roles
        // then we return all the requiredRoles
        return rolesUserDoesntHave.length !== requiredRoles.length
            ? []
            : requiredRoles;
    }
    // and rule
    return rolesUserDoesntHave;
};
//# sourceMappingURL=utils.js.map